<div *ngIf="hideHeader" class="service-title">
    {{ nameService }}
</div>
<div *ngIf="!hideHeader" class="bg-[#134F82] p-4 md:p-6 border-b-1 border-[#134F82] md:flex text-white flex">
    <mat-icon class="my-2 mr-4" (click)="goToBack()">arrow_circle_left</mat-icon>
    <h2 class="headline-06 md:mx-2 my-2">{{nameService}}</h2>
</div>
<div *ngIf="hideHeader" class="p-5"></div>
<div class="section-confirm">
    <h3 class="headline-06 m-4 md:mt-3 text-[#0E365A]">¿Cuándo lo necesitas?</h3>

    <button
        (click)="goToConfirm()"
        class="w-full mb-1 rounded-full bg-[#0E365A] text-white py-3 hover:bg-[#0c2f4e]">
        Lo antes posible
        <mat-icon class="">timer</mat-icon>
    </button>
    <button  *ngIf="selectedAgenda"
        (click)="toggleAgenda()"
        class="w-full mb-1 rounded-full bg-[#0E365A] text-white py-3 hover:bg-[#0c2f4e]">
        Agendar servicio
        <mat-icon  class="">
            {{ selectedAgenda ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
    </button>

    <div class="content-agenda" *ngIf="selectedAgenda">
        <div class="content-calendar">
            <h6 class="headline-03 m-4 md:mt-3 text-[#0E365A]">Agendar servicio</h6>
            <div class="calendar">
                <mat-calendar [(selected)]="selectedDate" (selectedChange)="onDateChange($event)"></mat-calendar>
            </div>
        </div>

        <div class="content-hour">
            <h6 class="headline-03 m-4 md:mt-3 text-[#0E365A]">Selecciona un horario</h6>
            <p class="headline-02 m-4 md:mt-3">La hora del servicio puede variar debido a la disponibilidad,
                recomendamos considerar una tolerancia de 20 minutos</p>

            <div class="buttons-hours">
                <button *ngFor="let hour of hoursDate; let i= index"
                    (click)="onHourChange(hour)"
                    class="w-full my-1 border border-[#0E365A] rounded-full p-1 text-center bold"
                    [class]="hour == selectedHour ? 'bg-[#0E365A] text-white':'' ">
                    {{hour.start}} - {{ hour.end}}
                </button>
            </div>
        </div>
    </div>
    <!--mat-progress-bar mode="determinate" value="50" class="mb-3 my-6"></mat-progress-bar-->

    <h6 class="headline-01 ml-2 ">Precio</h6>
    <div class="content-money flex">
        <mat-icon fontIcon="workspace_premium" class="text-[#382100]"></mat-icon>
        <p class="headline-01 p-2" style="width: 70%;">Cubierto por tu programa</p>
        <button
            *ngIf="selectedAgenda"
            [disabled]="!selectedDate && !selectedHour"
            (click)="goToConfirm()"
            [class]="selectedDate && selectedHour ?  'bg-[#0E365A] text-white':'bg-white text-[#0E365A]'"
            class="btn-solicitar mb-1 border  border-[#0E365A] rounded-full p-3 text-center">Solicitar</button>
    </div>

</div>
